const reviews = [
  {
    id: 1,
    name: "Mehmet Yılmaz",
    location: "İzmir",
    rating: 5,
    text: "Aliağa'da bu kadar taze balık yedim mi bilmiyorum. Levrek ızgara muhteşemdi, aile sıcaklığı ayrı bir güzellik. Kesinlikle tavsiye ederim!",
    avatar: "MY",
    color: "bg-[#e8734a]"
  },
  {
    id: 2,
    name: "Ayşe Kaya",
    location: "İstanbul",
    rating: 5,
    text: "İş seyahatinde uğradım, bir daha gitmek için bahane arıyorum. Midye dolma ve kalamar tava harika. Fiyat-kalite dengesi mükemmel.",
    avatar: "AK",
    color: "bg-[#2d7a6e]"
  },
  {
    id: 3,
    name: "Hasan Demir",
    location: "Aliağa",
    rating: 5,
    text: "Mahalle komşumuz gibi davrandılar. Balıkçı Tepsisi'ni söyleyin, pişman olmazsınız. Her hafta geliyoruz artık.",
    avatar: "HD",
    color: "bg-[#1a3a4a]"
  },
  {
    id: 4,
    name: "Fatma Şahin",
    location: "Manisa",
    rating: 5,
    text: "Aile yemeği için geldik, çok memnun kaldık. Çocuklar hamsi tavayı çok sevdi. Ortam temiz, personel güler yüzlü.",
    avatar: "FŞ",
    color: "bg-[#c0622a]"
  },
  {
    id: 5,
    name: "Kemal Arslan",
    location: "İzmir",
    rating: 5,
    text: "Ahtapot ızgara hayatımda yediğim en iyisiydi. Deniz kokusu, taze malzeme, ev sıcaklığı — hepsi bir arada. Bravo Zafer ailesi!",
    avatar: "KA",
    color: "bg-[#4a7a8a]"
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-[#e8734a]"></span>
              <span className="text-[#e8734a] text-sm font-semibold tracking-widest uppercase">Yorumlar</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a3a4a]" style={{ fontFamily: "'Playfair Display', serif" }}>
              Misafirlerimiz<br />
              <span className="text-[#e8734a]">Ne Diyor?</span>
            </h2>
          </div>
          <div className="flex items-center gap-3 bg-[#fdf8f4] rounded-2xl px-6 py-4">
            <div>
              <div className="text-3xl font-bold text-[#1a3a4a]">5.0</div>
              <div className="flex gap-0.5 mt-1">
                {[1,2,3,4,5].map(i => (
                  <i key={i} className="ri-star-fill text-[#e8734a] text-sm"></i>
                ))}
              </div>
              <div className="text-gray-400 text-xs mt-0.5">Google Yorumları</div>
            </div>
          </div>
        </div>

        {/* Reviews grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div key={r.id} className="bg-[#fdf8f4] rounded-2xl p-6 border border-orange-50 hover:-translate-y-0.5 transition-transform duration-200">
              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {[1,2,3,4,5].map(i => (
                  <i key={i} className="ri-star-fill text-[#e8734a] text-sm"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-600 text-sm leading-relaxed mb-5">
                &ldquo;{r.text}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 flex items-center justify-center ${r.color} rounded-full text-white text-xs font-bold flex-shrink-0`}>
                  {r.avatar}
                </div>
                <div>
                  <div className="text-[#1a3a4a] font-semibold text-sm">{r.name}</div>
                  <div className="text-gray-400 text-xs">{r.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
